<script setup lang="ts">
import { BsInput, BsError } from '@afo/bsf-core'
import type { IProps, IEmits } from './TextInput.types'

const props = withDefaults(defineProps<IProps>(), { trim: true })
const emit = defineEmits<IEmits>()

const onUpdateText = (event: string) => emit('update:modelValue', props.trim ? event.trim() : event)
</script>

<template>
  <BsError :message="errorMessage">
    <BsInput
      v-bind="$attrs"
      @update:model-value="onUpdateText($event)"
    />
  </BsError>
</template>
